import { Deserializable } from '../protocols/deserializable';
import { BankAccount } from '../../views/banking/models/bank-account';
import { WithdrawalInstruction } from './withdrawal-instruction';
import { ConsentWaiverAttachment } from './consent-waiver-attachment';
import { RecurringPaymentInstruction } from './recurring-payment-instruction';

export class VariableBenefitConfigurationSubmissionData implements Deserializable {
  public mandatoryRetirement!: boolean;
  public effectiveDate!: string;
  public desiredStartBalance!: number;
  public useEntireBalance!: boolean;
  public consentWaiverDateSigned!: string | null;
  public consentWaiverEffectiveDate!: string | null;
  public minimumAgeSpouseId!: number | null;
  public minimumAgeSpouseName!: string | null;
  public minimumAgeDateOfBirth!: string | null;
  public forgoRecurringPayments!: boolean;
  public lumpSumPaymentDesiredPaymentDate!: string | null;
  public lumpSumPaymentAmount!: number | null;
  public bankAccountId!: number | null;
  public bankAccount!: BankAccount;
  public recurringPaymentInstructions!: RecurringPaymentInstruction[];
  public withdrawalInstructions!: WithdrawalInstruction[];
  public consentWaiver!: ConsentWaiverAttachment | null;

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;

    if (this.bankAccount) {
      this.bankAccount = Deserialize.instanceOf(BankAccount, this.bankAccount);
    }

    if (this.withdrawalInstructions) {
      this.withdrawalInstructions = Deserialize.arrayOf(WithdrawalInstruction, this.withdrawalInstructions);
    }

    if (this.recurringPaymentInstructions) {
      this.recurringPaymentInstructions = Deserialize.arrayOf(
        RecurringPaymentInstruction,
        this.recurringPaymentInstructions
      );
    }

    if (this.consentWaiver) {
      this.consentWaiver = Deserialize.instanceOf(ConsentWaiverAttachment, this.consentWaiver);
    }
  }
}
